import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import LinkComponent from './LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

const LargeSwiperImage = ({ district, title, imageSrc, location }) => {
    return (
        <LinkComponent 
            onClick={() => sendGAEvent({ 
                event: "select_district",
                district_id: district.id,
                district_name: district.subdistrict,
                district_area: district.district,
                district_location: district.location,
            })} 
            href={`/properties?location=${location}`} className='relative district-swiper-large-image w-[150px] h-[300px]'>
            <div className='w-[140px] h-[290px] relative overflow-hidden rounded-md'>
                <Image
                    src={`/images/${imageSrc}.avif`}
                    fill={true}
                    className='object-cover'
                    alt={title}
                // style={{ objectFit: "contain" }}
                />
                <div className='absolute bottom-0 left-0 right-0 rounded-b-md flex justify-center h-[50px] items-start bg-maincolortrans overflow-hidden'>
                    <span className='text-light z-10 px-1 rounded-sm text-center'>{title}</span>
                </div>
            </div>
        </LinkComponent>
    )
}

export default LargeSwiperImage